import React, { PropsWithChildren } from 'react'
import css from './pageContent.module.scss'
type ReportPageContentProps = {
  isFiltered: boolean
} & PropsWithChildren<unknown>

const ReportPageContent: React.FC<ReportPageContentProps> = ({ isFiltered, ...props }) => {
  const height = isFiltered ? 'calc(100% - 290px)' : 'calc(100% - 190px)'
  return <div style={{ height }} className={css.report_page_content} {...props} />
}

export default ReportPageContent
